export default ">> **The logged in ServiceNow user should have the necessary privileges to create ServiceNow incidents.**";